import styled from 'styled-components'
import CommonStyles from 'shared/style/commonPageStyles'

const Style = {
	Wrapper: CommonStyles.PageWrapper,
	AreaDiv: CommonStyles.AreaDiv,
	LogoImg: styled.img`
		width: 185px;
		height: 185px;
		object-fit: contain;
	`,

	Tab: CommonStyles.Tab,
	Radio: styled.button`
		display: flex;
		align-items: center;
		gap: 8px;
	`,
	
	ModalReturnWrapper: styled.div`
		width: 400px;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 16px;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			width: 300px;
		}
	`,
	SelectWrapper: styled.div`
		position: relative;
		display: flex;
		width: 100%;
		height: 40px;
		background-color: ${({theme}) => theme.color.grey1};

		& > select {
			width: 100%;
			${({theme}) => theme.font.extra_small};
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;
			padding: 10px 8px;
			padding-right: 28px;
			appearance: none;
			-webkit-appearance: none;
			-moz-appearance: none;
			cursor: pointer;
		}

		img {
			position: absolute;
			right: 8px;
			top: 50%;
			transform: translateY(-50%);
			pointer-events: none;
			width: 12px;
			height: 12px;
		}
	`,
	GiveDiv: styled.div`
		display: flex;
		gap: 8px;
		width: 100%;
		height: 40px;

		& > input {
			${({theme}) => theme.font.extra_small};
			flex: 1;
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;
			padding: 10px 8px;
		}
	`,

	VoucherTableWrapper: styled.div`
		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			overflow-x: auto;
			-webkit-overflow-scrolling: touch;
		}
	`,

	VoucherTableDiv: styled.div`
		display: flex;
		flex-wrap: wrap;
		border-top: 1px solid ${({ theme }) => theme.color.grey2};

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			min-width: 600px;
		}
	`,
	
	VoucherItem: styled.div`
		display: flex;
		border-bottom: 1px solid ${({ theme }) => theme.color.grey2};

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			min-width: 600px;
		}
	`,
	
	VoucherRow: styled.div`
		flex-basis: 33.33%;
		flex-shrink: 0;
		display: flex;
		align-items: center;

		& > p {
			${({theme}) => theme.font.small};
			font-size: 12px;
			padding: 11px 20px;
		}
	`,

	VoucherRowRight: styled.div`
		flex-basis: 33.33%;
		flex-shrink: 0;
		flex-grow: 1;
		display: flex;
		align-items: center;

		& > p {
			${({theme}) => theme.font.small};
			font-size: 12px;
			padding: 11px 20px;

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				padding: 11px 10px;
			}
		}
	`,

	VoucherLabelLeft: styled.h2`
		${({theme}) => theme.font.small_bold};
		font-size: 12px;
		min-width: 80px;
		display: flex;
		align-items: center;
		width: 80px;
		background-color: ${({theme}) => theme.color.grey1};
		padding: 13px 20px;
		height: 100%;
		flex-shrink: 0;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			min-width: 40px;
			width: 40px;
			padding: 11px 10px;
			justify-content: center;
		}
	`,

	VoucherLabelRight: styled.h2`
		${({theme}) => theme.font.small_bold};
		font-size: 12px;
		min-width: 200px;
		display: flex;
		align-items: center;
		width: 200px;
		background-color: ${({theme}) => theme.color.grey1};
		padding: 13px 20px;
		height: 100%;
		flex-shrink: 0;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			min-width: 70px;
			width: 70px;
			padding: 11px 10px;
			justify-content: center;
		}
	`,


}

export default Style
